import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createGetAction,
  createGetOneHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { headcountDashboardMapper } from '../headcountMappers';
import type { HeadcountDashboard, HeadcountDashboardApiBody } from '../headcountTypes';

const actionConfig = {
  resourcePath: '/dashboards/headcount/snapshot',
};

type HeadcountSnapshotState = RestStoreState<HeadcountDashboardApiBody>;

const genericActions = createRestActions<HeadcountDashboardApiBody, HeadcountDashboard>(
  actionConfig,
  headcountDashboardMapper,
);

const headcountSnapshotActions = {
  ...genericActions,
  loadForYear: (year: number) => async ({ dispatch, getState }: StoreActionApi<HeadcountSnapshotState>) => {
    const getAction = createGetAction<HeadcountDashboardApiBody>({
      resourcePath: actionConfig.resourcePath,
    });
    await dispatch(getAction({ params: { year } }));
    const { data: snapshotList } = getState();
    const first = snapshotList[0];
    return first ? headcountDashboardMapper.toModel(first) : undefined;
  },
  clearHeadcountSnapshot: () => ({ setState }: StoreActionApi<HeadcountSnapshotState>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const HeadcountSnapshotStore = createRestStore<HeadcountDashboard, HeadcountDashboardApiBody>({
  actions: headcountSnapshotActions,
  actionConfig,
  containerDisplayName: 'headcount-snapshot-container',
  onInitAction: null,
  mapper: headcountDashboardMapper,
});

export const useHeadcountSnapshotRecord = createGetOneHook(HeadcountSnapshotStore);
export const useHeadcountSnapshotIsLoading = createLoadingHook(HeadcountSnapshotStore);
export const useHeadcountSnapshotActions = createActionsHook(HeadcountSnapshotStore);
